import { render, staticRenderFns } from "./addpackagename.vue?vue&type=template&id=6b62b5f0&"
import script from "./addpackagename.vue?vue&type=script&lang=js&"
export * from "./addpackagename.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b62b5f0')) {
      api.createRecord('6b62b5f0', component.options)
    } else {
      api.reload('6b62b5f0', component.options)
    }
    module.hot.accept("./addpackagename.vue?vue&type=template&id=6b62b5f0&", function () {
      api.rerender('6b62b5f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/updateConfiguration/components/addpackagename.vue"
export default component.exports